import { render } from "./OnboardingSidebar.vue?vue&type=template&id=f15c44f0&scoped=true"
import script from "./OnboardingSidebar.vue?vue&type=script&lang=js"
export * from "./OnboardingSidebar.vue?vue&type=script&lang=js"

import "./OnboardingSidebar.vue?vue&type=style&index=0&id=f15c44f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15c44f0"]])

export default __exports__